// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"8780992f","462":"fdb59a40","550":"f5708154","720":"6061b013","725":"cbd94f6e","844":"acf39096"}[chunkId] + ".chunk.js";
};